let ctx = null;
let enabled = true;
let chargeNodes = null;

const ac = () => {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
};

export const setSfxEnabled = (v) => {
    enabled = v;
    if (!v) stopCharge();
};

const blip = (freq, dur, type = "square", vol = 0.12, delay = 0) => {
    if (!enabled) return;
    try {
        const c = ac();
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = type;
        o.frequency.value = freq;
        const t = c.currentTime + delay;
        g.gain.setValueAtTime(vol, t);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        o.connect(g);
        g.connect(c.destination);
        o.start(t);
        o.stop(t + dur + 0.02);
    } catch (e) { /* audio unavailable */ }
};

export const startCharge = () => {
    if (!enabled || chargeNodes) return;
    try {
        const c = ac();
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = "sawtooth";
        o.frequency.setValueAtTime(70, c.currentTime);
        o.frequency.linearRampToValueAtTime(430, c.currentTime + 1.5);
        g.gain.value = 0.04;
        o.connect(g);
        g.connect(c.destination);
        o.start();
        chargeNodes = { o };
    } catch (e) { /* audio unavailable */ }
};

export const stopCharge = () => {
    if (!chargeNodes) return;
    try {
        chargeNodes.o.stop();
    } catch (e) { /* already stopped */ }
    chargeNodes = null;
};

export const playLaunch = () => {
    if (!enabled) return;
    try {
        const c = ac();
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = "triangle";
        o.frequency.setValueAtTime(520, c.currentTime);
        o.frequency.exponentialRampToValueAtTime(90, c.currentTime + 0.28);
        g.gain.setValueAtTime(0.16, c.currentTime);
        g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.3);
        o.connect(g);
        g.connect(c.destination);
        o.start();
        o.stop(c.currentTime + 0.32);
    } catch (e) { /* audio unavailable */ }
};

export const playScore = () => {
    blip(523, 0.09);
    blip(659, 0.09, "square", 0.12, 0.09);
    blip(784, 0.18, "square", 0.12, 0.18);
};

export const playPerfect = () => {
    playScore();
    blip(1047, 0.2, "square", 0.12, 0.28);
    blip(1319, 0.32, "square", 0.1, 0.4);
};

export const playMiss = () => {
    blip(140, 0.25, "sawtooth", 0.13);
    blip(88, 0.38, "sawtooth", 0.11, 0.12);
};
